/*
 * File: alert-response2.ts
 * File Created: 2024-01-08 04:25:28
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:44:28
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import Modal from "../../modal/modal";
import { createCustomPrevent } from "@root/core/event-modifier/create-custom-prevent";

@Component
export default class AlertResponse extends Modal {
    @Prop({ type: Object, required: false })
    declare data: IAlertResponseData;

    get mergedData() {
        return {
            ...defaultData,
            ...this.data,
        };
    }

    /// handle event - submit
    doSubmit(e) {
        const customEvent = createCustomPrevent();
        this.$emit("submit", customEvent);
        if (!customEvent.defaultPrevented) {
            this.hide();
        }
    }
}

export interface IAlertResponseData {
    "text-submit"?: string;
}

const defaultData: IAlertResponseData = {
    "text-submit": "w_Close",
};
